import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1024"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.245 8.952V5.076a.5.5 0 0 0-1 0v3.89a1.995 1.995 0 0 0 .522 3.922 1.997 1.997 0 0 0 .478-3.936z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M13.937 7.825V3.823C13.922 2.142 12.543.779 10.899.779c-1.684 0-3.083 1.43-3.038 3.153a3.204 3.204 0 0 0-1.48-.176 3.291 3.291 0 0 0-2.844 3.683 3.284 3.284 0 0 0 3.097 2.866c-.027.193-.059.385-.059.583a4.335 4.335 0 0 0 4.325 4.334 4.335 4.335 0 0 0 4.325-4.334c0-1.15-.466-2.248-1.288-3.063zm-3.038 5.952a2.89 2.89 0 0 1-2.883-2.889c0-.837.376-1.637 1.032-2.194a.724.724 0 0 0 .256-.551v-4.32A1.6 1.6 0 0 1 10.9 2.224a1.6 1.6 0 0 1 1.596 1.599v4.319c0 .213.094.414.255.551a2.88 2.88 0 0 1 1.032 2.194 2.89 2.89 0 0 1-2.884 2.89z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M6.227 3.136a.658.658 0 0 0 .651-.74l-.136-1.077A.669.669 0 0 0 6.008.75a.658.658 0 0 0-.568.734l.137 1.077a.658.658 0 0 0 .65.575zM2.893 4.669a.653.653 0 0 0 .92-.118.658.658 0 0 0-.117-.922l-.857-.664a.658.658 0 0 0-.92.117.66.66 0 0 0 .117.922l.857.665zM2.97 7.31a.664.664 0 0 0-.732-.569l-1.077.137a.657.657 0 0 0 .166 1.304l1.075-.138a.658.658 0 0 0 .568-.734zm.37 2.84-.664.859a.66.66 0 0 0 .117.922.65.65 0 0 0 .92-.118l.664-.859a.657.657 0 1 0-1.037-.804z" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }